import Base from './base'
import { Group } from '../types/group'

export default class Groups extends Base {
  async getGroups(): Promise<Group[]> {
    return this.api.get('groups.json')
  }
}
